import { Component } from '@angular/core';
import {IonicPage, NavController,AlertController, LoadingController, NavParams ,ActionSheetController} from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { PasswordPage } from '../password/password';
import { ForgotMobileNumberPage } from '../forgot-mobile-number/forgot-mobile-number';
import { CreateNewPasswordPage } from '../create-new-password/create-new-password';
import { HomePage } from '../home/home';
import {OtpPage} from '../otp/otp'

/**
 * Generated class for the UpdateladlinenumberPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updateladlinenumber',
  templateUrl: 'updateladlinenumber.html',
})
export class UpdateladlinenumberPage {

  dailingCodes:any=[];
  errorDisplay:any={};
  country_code:any="";
  phone_number: any;
  old_phone_number: any;
  code:any;
  ccs_remarks:any;
  email:any;
  constructor(public actionSheetCtrl: ActionSheetController,public navCtrl: NavController, public navParams: NavParams,
    private fb: FormBuilder,
    private cp: CommonProvider,
    private alertController: AlertController,
    private fv : GenericFormValidationProvider,
    private loadingCtrl: LoadingController) {
  }

  ionViewDidLoad() {
    
    
    if(this.navParams.get('updateeladline')){
      this.code = this.navParams.get('code');
      this.phone_number = this.navParams.get('phone_number')
      this.old_phone_number=this.navParams.get('old_phone_number');
     // this.officialemail=this.navParams.data.queryParams.emailid;
      // console.log("Details",this.navParams.data.queryParams);
      this.email=this.navParams.get('emailid');
      this.generateLadlineNumberSr();
    }else{
      this.phone_number = this.navParams.data.queryParams.phone1;
      this.old_phone_number=this.navParams.data.queryParams.phone1;
      this.email=this.navParams.data.queryParams.emailid;
      this.code=this.navParams.data.queryParams.stdcode;
      //console.log('ionViewDidLoad Contact details change page',this.navParams);
    }
     
    
  }
   
   
    
   
 presentActionSheet(title?:any,msg?:any) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      
      buttons: [
        {
          text: 'OK',
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  } 
 postFormForValidation(){
    // this.navParams.data.queryParams.phone1=this.phone_number;
    // this.old_phone_number=this.navParams.data.queryParams.phone1;
    // this.email='radhay.shyam@sammaancapital.com';//this.navParams.data.queryParams.emailid;
    // this.navParams.data.queryParams.stdcode=this.code;
    if(this.old_phone_number==this.phone_number){
      
      this.presentActionSheet("Error","The ladline number you are trying to enter is the same as the one in our records.Please enter a diffrent ladline number.")

      return false;
    }
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    console.log(this.errorDisplay)
    if(this.errorDisplay.valid){
     return false;
   }else{
    this.navCtrl.push(OtpPage,{email:this.email,type:"updateeladline",queryParams:this.navParams.data.queryParams,"phone_number":this.phone_number,"code1":this.code,"old_phone_number":this.old_phone_number})
    
   
   }
   }
 
  generateLadlineNumberSr(){
    var ccs_casecategory="CC02";;
    var ccs_casetype="CT02";
    var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
    var ccs_originatingsource="S011"
    var ccs_casesubtype = "ST109";
    var ccs_remarks = this.ccs_remarks;
    var ibhfl_newmobileno = this.phone_number;
    var ibhfl_typeofcontactupdate=303710001;
    var ibhfl_customername =  this.navParams.data.queryParams.customername;
    var ibhfl_addresstypes =  this.navParams.data.queryParams.addresstype;
    
    
    var ibhfl_stdcode = this.code;
    let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
     loading.present()

    this.cp.postContactDetailsUpdateLadlineQuery(loading,ccs_casecategory,ccs_remarks,
                           "404276",ccs_casetype,
                           ibhfl_loanaccountnumber1,
                           ccs_originatingsource,
                           ccs_casesubtype,ibhfl_customername,
                           ibhfl_typeofcontactupdate,
                           ibhfl_newmobileno,
                           ibhfl_stdcode,ibhfl_addresstypes).then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res)
                            this.presentActionSheet("","Your SRno. "+res.Payload.caseid+" has been resolved.")
                           })
  } 
  goToForgotMobile(){
    //this.navCtrl.push(ForgotMobileNumberPage)
  }
}

 



// WEBPACK FOOTER //
// ./src/pages/updateladlinenumber/updateladlinenumber.ts